export default {
  common: {
    projectList: "项目列表",
    pleaseInputProjectName: "关键字搜索",
    pipeline: "流转中",
    onhold: "已暂停",
    win: "已赢得",
    loss: "未赢得",
    city: "城市",
    amount: "金额",
    winProbability: "赢得概率",
    registeredOn: "注册于",
    updatedOn: "更新于",
    thereAreNoMoreProjectsLeft: "没有更多项目了",

    drafting: "初始状态",
    ready: "就绪",
    shared: "已分享",
    negotiating: "正在进行",
    secured: "已成交",
    lost: "已丢失",

    INITIAL: "初始状态",
    ECM_REPORT_PREPARED: "ECM报告等待客户共享",
    ECM_TO_CUSTOMER: "ECM报告发送给客户",
    CUSTOMER_KIV_PROPOSAL: " 客户保持关注建议",
    CUSTOMER_FUNDED: "客户确认项目已获资助",
    CUSTOMER_PROPOSAL: "客户就提案进行谈判",
    EA_TO_CUSTOMER: "EA报告发送给客户",
    CUSTOMER_ORDERS: "客户下单",
    LOST_TO_COMPETITION: "输给竞争对手",
    STATUS_PROJECT: "另一个项目中报告的状态",
    IN_ACTIVE: "项目暂停",
    getProjectInfoFailed: "项目数据获取失败",
    getCitylistFailed: "获取城市列表失败",
    cantGetProjectDetails: "获取项目详情失败",
    noProjectId: "缺少项目标识",
    noProjectState: "缺少项目状态",
    enterProjectName: "输入项目名称",
    noActualEcmQuoted: "缺少实际ECM报价",
    submitter: "提交人",

    zone: "所属区域",
    start: "开始日期",
    end: "结束日期",
    clear: "清除",
    search: "搜索",

    details: "详情",
    delete: "删除",
    cancel: "取消",
    report: "报告",
    ok: "确定",
    confirm: "确认",

    preRetrofitReport: "改造前报告",
    postRetrofitReport: "改造后报告",
    downloadProjectReport: "下载项目详情&报告",
    sureDelProject: "您确认要删除这个项目吗 ?",
    projectDetail: "项目详情导出",
    status: "项目状态",

    today: "今天",
    yesterday: "昨天",
    daysAgo: "天以前",
    resetLastDate: "重设更新日期",

    sure30days: "您确认30天都没有任何更新吗？",
    resetUpdateToToday: "重设日期到今天",
    updateOrReset: "更新最后日期",
    insufficientPermissions: "权限不足",

    projectNotFound: "没有找到项目信息",
    sendToSFDC: "发送到 SFDC"
  },
  salesforce: {
    integrationStatus: "Salesforce 集成状态",
    leadNotApplicable: "Lead 状态不适用",
    leadTransferred: "Lead 已转移至 Salesforce",
    leadTransferFailed: "Lead 转移失败",
    opportunityNotApplicable: "Opportunity 状态不适用",
    opportunitySynchronized: "Opportunity 已与 Salesforce 同步",
    opportunitySyncPending: "Opportunity 同步待处理",
    opportunitySyncFailed: "Opportunity 同步失败",
    lastSyncAttempt: "上次数据传输尝试：{date}",
    lastSynced: "上次数据传输：{date}",
    lastAttempt: "上次尝试：{date}",
    lastUpdate: "上次更新：{date}",
    readyForSFDC: "可发送至 SFDC",
    sentToSFDC: "已发送至 SFDC",
    SFDCTransferFailed: "SFDC 传输失败",
    SendToSFDCOpportunityTitle: "Salesforce → iECM Spec Builder",
    SendToSFDCOpportunityDescription: "将 Opportunity 发送至 iECM 进行分析。分析完成后，报告将作为一次性传输发送回 SFDC。",
    SendToSFDCLeadTitle: "iECM Spec Builder → Salesforce",
    SendToSFDCLeadDescription: "将 Lead 发送至 SFDC，以便分配给销售人员。该 Lead 将作为一次性传输进入销售线索漏斗，以便转化为 Opportunity。"
  },
  projectDlg: {
    newProject: "新建项目",
    projectName: "项目名称",
    projectState: "项目状态",
    customer: "客户",
    address: "项目地址",
    customerEmail: "客户邮箱",
    auditDate: "审计日期",
    jobsiteCity: "工地所在城市",
    estimatedEcmQuoted: "评估ECM报价",
    exceptedOrder: "预估订单日期",
    winProbability: "赢得概率 %",
    saveRetrun: "保存并返回",
    saveAudit: "保存并审计",
    statusRemarks: "项目描述",

    actualEcmQuoted: "实际ECM报价",
    actualOrder: "实际订单日期",

    projectCreationMethod: "项目创建方式",

    duplicate: "复制项目",
    manualInput: "新项目",
    duplicateFromOtherProject: "使用现有项目作为模板",
    manuallyInputToCreateProject: "从一个空白项目开始",

    defaultValue: "借助默认值来创建项目",
    enterKeyDataUseDefaultValues: "输入少量的关键数结合默认值来快速创建项目",
    copyFrom: "拷贝来源",
    enterMoreInformation: "需要输入更多信息",
    pleaseSelectOne: "请先选择一项",

    projectNameRequire: "'项目名称'必填",
    duplicateFromRequire: "'拷贝来源'必填",
    stateIn1CantEditIn2: "该项目在1.0种的状态为赢得, 失去或保留, 所以无法在2.0种进行修改.",

    lastUpdateDate: "最后更新日期",

    intelligentInsightfulImpactful: "智能节能改造方案",
    carriersSoftware: "iECM Spec Builder：用于冷热源机房改造，创建新规范，或响应他人编制的规范。",
    intelligent: "智能",
    intelligentDetails: "创建新的招标技术规范 → 主动型（塑造项目机会）；或验证并响应现有招标要求 → 响应型（询价/投标响应）。",
    insightful: "洞察",
    insightfulDetails: "评估拟议设计是否达到既定能效目标，制定控制策略，并通过明确的性能保证提供支持。",
    impactful: "有成效",
    impactfulDetails: "生成面向客户的专业提案及具有竞争力的替代方案，并提供能效对比、图表、投资回报率和投资回收期分析。",
    startNewAnalysis: "开始创建改造方案",

    reassignProject: "转发项目",
    advancedSearch: "高级搜索",
    viewAuditData: "浏览审计数据",

    customerID: "客户 ID",
    copyFromSalesforce: "从 Salesforce 复制"
  },

  downloadReportDlg: {
    retrofitSolution: "改造方案",
    proposal: "方案",
    proposalUpper: "方案",
    autoConfig: "自动配置",
    userConfig: "用户配置"
  },

  wizardDlg: {
    quickAssessmentMode: "快速评估",
    quickAssessmentModeDetails: "用于快速评估机会的引导式向导",
    detailedAssessmentMode: "详细评估",
    detailedAssessmentModeDetails: "为已验证的客户方案提供完整分析",
    title: "iECM"
  }
}



// WEBPACK FOOTER //
// ./src/locale/projectList/zh.js